// extracted by mini-css-extract-plugin
export var card = "_ul-0";
export var details = "_ul-1";